import { useState } from 'react';
import { LinkButton } from '../../ui';
import { useLocale, useStrings } from '../../state/useLocale';
import { duePractice, readPractice } from '../../lib/learning-practice';

export function PracticeReview({ userId, clearedAt }: {
  userId: string | null; clearedAt: (mission: string) => number | null;
}) {
  const s = useStrings().learning;
  const { locale } = useLocale();
  const [due] = useState(() => duePractice(readPractice(userId), Date.now(), clearedAt));
  if (!due.length) return null;
  return <section className="learning-review" aria-label={s.due}>
    <h2>{s.due}</h2><p>{s.dueNote}</p>
    {due.map((lesson) => <LinkButton key={lesson.mission} variant="quiet"
      href={`?mission=${encodeURIComponent(lesson.mission)}&practice=review`}>
      {s.revisit}: {lesson.text[locale].title}
    </LinkButton>)}
  </section>;
}
